<template>
  <modal
    width="68"
    title="Process Return"
    v-loading="loading"
    :show-modal="showModal"
    @close-modal="$emit('close-modal')"
  >
    <div class="flex items-center mt-6">
      <div class="single-option">
        <label for="delivery" class="radio-label">
          <input
            type="radio"
            v-model="returnType"
            value="Delivery"
            id="delivery"
            name="routeEnd"
          />
          Deliver to my Address
          <span></span>
        </label>
      </div>

      <div class="single-option">
        <label id="pickup" class="radio-label">
          <input
            type="radio"
            v-model="returnType"
            value="pickUp"
            id="pickup"
            name="routeEnd"
          />
          Pick-up from Terminal
          <span></span>
        </label>
      </div>
    </div>

    <div class="mt-4">
      <label>Return Address:</label>
      <input
        v-if="returnType == 'Delivery'"
        placeholder="Shipper’s name loaded by default but can be edited"
        class="w-full p-2 bg-gray-200"
        v-model="address"
        list="countrydata"
      />
      <el-select
        v-else
        filterable
        v-model="terminal"
        placeholder="Select handling requirements"
      >
        <el-option
          v-for="location in locations"
          :key="location.id"
          :label="location.locationName"
          :value="location.locationName"
        >
        </el-option>
      </el-select>
    </div>

    <div class="flex items-center my-6 w-11/12 flex-wrap">
      <div class="text-sm col-md-6 col-12">
        <label>Preferred Delivery</label>
        <el-date-picker
          type="date"
          class="w-full"
          v-model="deliveryDate"
          placeholder="Pick a time"
        >
        </el-date-picker>
      </div>
      <div class="text-sm col-md-6 col-12 flex justify-between flex-wrap">
        <div class="col-md-5 col-12">
          <label class="opacity-50">FROM</label>
          <el-time-picker
            type="date"
            v-model="deliveryTime_1"
            placeholder="Pick a time"
          >
          </el-time-picker>
        </div>
        <div class="col-md-5 col-12">
          <label class="opacity-50">TO</label>
          <el-time-picker
            type="date"
            v-model="deliveryTime_2"
            placeholder="Pick a time"
          >
          </el-time-picker>
        </div>
      </div>
    </div>

    <div>
      <b class="pb-3">Select Shipping Service</b>
      <div>
        <div class="overflow-auto whitespace-no-wrap">
          <div
            v-for="(item, index) in shippingService"
            class="mr-2 my-2 zoom"
            :key="index"
            @click="shippingServiceId = item.id"
            :class="[shippingServiceId == item.id ? 'active-tab' : 'dull-tab']"
          >
            <p class="opacity-75">{{ item.orgName ? item.orgName : "N/A" }}</p>
            <p class="opacity-50 py-3 text-sm">
              {{
                (item.takeOffLocation || "N/A") +
                  " - " +
                  (item.arrivalLocation || "N/A")
              }}
            </p>
            <p class="mt-1">
              Arrives {{ item.arrivalTime ? item.arrivalTime : "N/A" }}
            </p>
            <p class="mt-3 opacity-50">
              {{ item.shippingMethod ? item.shippingMethod : "N/A" }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full pb-10 flex flex-wrap">
      <label class=" w-full mt-4">Select Costs</label>
      <div class="overflow-auto whitespace-no-wrap">
        <div
          v-for="(item, index) in Object.keys(cost)"
          class="mr-3 my-2 zoom"
          :key="index"
          @click="setCostEngine(index)"
          :class="[costId == index ? 'active-tab' : 'dull-tab']"
        >
          <p class="mt-3 uppercase text-base">
            {{ item.replace("Cost", "") }}
          </p>
          <p class="font-bold text-2xl pt-3">
            <Sup>₦</Sup
            >{{ amountFomatter(Object.values(cost)[index].totalCost) }}
          </p>
        </div>
      </div>
    </div>

    <div class="flex items-center justify-between">
      <button>Cancel</button>
      <el-dropdown
        class="h-full text-white"
        :class="[!procedToPayment ? 'opacity-50' : 'opacity-100']"
      >
        <button
          :disabled="!procedToPayment"
          class="payment-assignqs h-full font-semibold rounded flex items-center p-2 bg-primary-yellow"
        >
          <span class=" mr-3 pr-2">Make Payment</span>

          <arrow-down-filled />
        </button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <button>
              Charge Card
            </button>
          </el-dropdown-item>

          <el-dropdown-item>
            <button>
              Charge Wallet
            </button>
          </el-dropdown-item>

          <el-dropdown-item>
            <button @click="showPaymentModalFunc">
              Pay with Paystack
            </button>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <PaymentModal
      @close-modal="showPaymentModal = false"
      :show-modal="showPaymentModal"
      :total="costEngine.totalCost ? costEngine.totalCost : '10'"
      :costEngine="costEngine"
    />
  </modal>
</template>

<script>
import PaymentModal from "./PaymentModal.vue";
import moment from "moment";



export default {
  props: {
    locations: {
      type: Array,
    },
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  components: { PaymentModal },
  mounted() {
    console.log(this.user);
  },
  computed: {
    user() {
      return JSON.parse(localStorage.getItem("loggedInUser"));
    },
    procedToPayment() {
      return this.costId != undefined;
    },
    shipping() {
      return this.$store.getters.newCurrentShipping;
    },
    costPayload() {
      return {
        shippingId: this.shipping.id,
        shippingServiceId: this.shippingServiceId,
        type: "single",
      };
    },
    deliveryTimeFormat() {
      return [
        this.deliveryTime_1
          ? moment(this.deliveryTime_1).format("HH:MM")
          : null,
        this.deliveryTime_2
          ? moment(this.deliveryTime_2).format("HH:MM")
          : null,
      ];
    },
    payload() {
      return {
        transaction: {
          status: "paid",
          userId: this.user?.id,
          orgId: this.user.orgId,
          totalValue: this.costEngine?.totalCost,
          paymentStatus: "paid",
          breakDown: {
            vat: 0,
            insuranceFee: 0,
            handlingCharges: 0,
          },
          amount_paid: this.costEngine?.totalCost,
          payment_type: "card",
          shippingId: this.shipping?.id,
          userType: "private",
        },
        shipperLocationId: this.shipping?.shipperLocationId,
        shippingMethod: "drop-off",
        returnOrForwardingAddress: this.address,
        deliveryDays: this.deliveryDate
          ? moment(this.deliveryDate).format("YYYY-MM-DD")
          : undefined,
        deliveryTime: this.deliveryTimeFormat,
      };
    },
  },
  data() {
    return {
      returnType: "Delivery",
      loading: false,
      method: "Deliver to my Address",
      address: "",
      shippingService: [],
      shippingServiceId: undefined,
      deliveryDate: "",
      deliveryTime_1: "",
      deliveryTime_2: "",
      cost: {},
      costEngine: {},
      costId: undefined,
      terminal: "",
      showPaymentModal: false,
    };
  },

  watch: {
    showModal(){
      this.shippingService = [],
      this.cost = {},
      this.getShippingService()
    },
    // shipping() {
    //   this.getShippingService();
    // },
    shippingServiceId() {
      this.getCostEngine();
    },
  },

  methods: {
    setCostEngine(index) {
      this.costId = index;
      this.costEngine = { ...Object.values(this.cost)[index] };
    },
    showPaymentModalFunc() {
      this.$store.dispatch("saveProcessReturnDetails", this.payload);
      this.showPaymentModal = true;
    },
    async getShippingService() {
      try {
        let payload = {
          shipperLocationId: this.shipping.shipperLocationId,
          consigneeLocationId: this.shipping.consigneeLocationId,
        };
        await this.$_getAllNewShippingService(payload).then((response) => {
          this.shippingService = response.data.data.shippingServices;
        });
      } catch (error) {
        this.handleError(error);
      }
    },
    getCostEngine() {
      try {
        this.$_getCostEngine(this.costPayload).then((response) => {
          this.cost = response.data.data;
        });
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.single-option {
  @apply mr-4;
}
.zoom {
  transition: 0.6s;
  display: inline-block;
  margin-left: 5px;
  transform: scale(1);
}
.zoom:hover {
  transform: scale(1.03);
}
.dull-tab {
  @apply p-3 border-2 border-gray-400 bg-gray-100 text-center py-8 duration-300;
  width: 230px;
}
.active-tab {
  width: 230px;
  @apply p-3 border-2 border-gray-400 bg-primary-navy text-white text-center py-8 duration-300;
}
</style>
